import CreateVouchers from "../../features/dashboard/vouchers/CreateVouchers";

export default function Vouchers() {
  return (
    <CreateVouchers/>
  )
}
